// client/src/components/MobileNavbar.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaTimes, FaUser } from 'react-icons/fa';
import './MobileNavbar.css';

function MobileNavbar({ menuOpen, toggleMenu }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`mobile-navbar-container ${isRTL ? 'rtl' : ''}`}>
      <header className="header">
        <div className="container">
          {/* Always render the menu toggle and login icon */}
          <button className={`menu-toggle ${!menuOpen ? 'menu-closed' : ''}`} onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Conditionally render logo based on menuOpen */}
          {menuOpen ? (
            <div className="logo">
              <Link to="/">beinSmart</Link>
            </div>
          ) : (
            <div className="logo logo-center">
              <Link to="/">beinSmart</Link>
            </div>
          )}

          {/* Always render the login icon */}
          <Link to="/login" className={`login-link ${!menuOpen ? 'login-closed' : ''}`}>
            <FaUser />
          </Link>
        </div>
      </header>

      <nav className={`navbar ${menuOpen ? 'open' : ''}`}>
        <div className="container">
          <ul>
            <li><NavLink to="/" end onClick={toggleMenu}>{t('header.home')}</NavLink></li>
            <li><NavLink to="/services" onClick={toggleMenu}>{t('header.services')}</NavLink></li>
            <li><NavLink to="/products" onClick={toggleMenu}>{t('header.products')}</NavLink></li>
            <li><NavLink to="/blog" onClick={toggleMenu}>{t('header.blog')}</NavLink></li>
            <li><NavLink to="/about" onClick={toggleMenu}>{t('header.aboutUs')}</NavLink></li>
            <li><NavLink to="/contact" onClick={toggleMenu}>{t('header.contact')}</NavLink></li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default MobileNavbar;